import React, { useEffect, useRef, useState } from "react";
import { useGlobalContext } from "../../../Context/global.context";
import { getUserFromToken } from "../../../Context/functions";

const PatientMedCheck = () => {
  const gc = useGlobalContext();
  const { activePatient, setActivePatient } = gc || {};

  const [text, setText] = useState(activePatient?.medCheckData ?? "");
  const originalRef = useRef(activePatient?.medCheckData ?? "");
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const next = activePatient?.medCheckData ?? "";
    originalRef.current = next;
    setText(next);
    setStatus(null);
  }, [activePatient]);

  const isDirty = (text ?? "") !== (originalRef.current ?? "");
  const canSave = !!activePatient?.id && !saving && isDirty;

  const onSave = async () => {
    if (!canSave) return;
    setSaving(true);
    setStatus(null);

    try {
      const userData = await getUserFromToken();
      const res = await fetch("https://gdmt.ca/PHP/special.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        body: JSON.stringify({
          script: "updatePatientAiField",
          patientID: activePatient.id,
          fieldName: "medCheckData",
          value: text,
          patientDB: userData?.patientTable || "Patient",
          historyDB: userData?.historyTable || "Patient_History",
        }),
      });

      let data = null;
      try { data = await res.json(); } catch {}
      const ok = !!(data && data.success === true);

      if (res.ok && ok) {
        originalRef.current = text;
        setActivePatient?.({ ...(activePatient || {}), medCheckData: text });
        setStatus("ok");
      } else {
        setStatus("err");
      }
    } catch {
      setStatus("err");
    } finally {
      setSaving(false);
    }
  };

  const onCancel = () => {
    setText(originalRef.current);
    setStatus(null);
  };

  return (
    <div className="d-flex flex-column w-100 h-100" style={{ minHeight: 0 }}>
      <label htmlFor="patient-medcheck-textarea" className="form-label fw-bold mb-2">
        MedsCheck
      </label>

      <div className="flex-grow-1 d-flex" style={{ minHeight: 0 }}>
        <textarea
          id="patient-medcheck-textarea"
          className="form-control fs-7 flex-grow-1"
          value={text}
          maxLength={12000}
          onChange={(e) => { setStatus(null); setText(e.target.value); }}
          placeholder="Enter MedsCheck documentation for this patient..."
          style={{ whiteSpace: "pre-wrap", minHeight: 0, overflow: "auto" }}
          rows={10}
        />
      </div>

      <div className="d-flex align-items-center mt-2 gap-2">
        <button
          type="button"
          className={`btn btn-sm ${isDirty ? "btn-success text-white" : "btn-outline-success"}`}
          disabled={!canSave}
          onClick={onSave}
          title={saving ? "Saving..." : (isDirty ? "Save changes" : "No changes to save")}
        >
          {saving ? "Saving..." : "Save MedsCheck"}
        </button>

        {isDirty && (
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            disabled={saving}
            onClick={onCancel}
            title="Revert to previous text"
          >
            Cancel
          </button>
        )}

        <div className="ms-auto d-flex align-items-center gap-2 pe-2">
          {status === "ok" && <span className="badge bg-success">Saved</span>}
          {status === "err" && <span className="badge bg-danger">Save failed</span>}
          <small className="text-muted">{(text || "").length}/12000</small>
        </div>
      </div>

      {!activePatient?.id && (
        <div className="text-muted small mt-1">(No active patient selected)</div>
      )}
    </div>
  );
};

export default PatientMedCheck;
